import { Component, OnInit, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';
import { global } from '../../shared/global';
import { HttpErrorResponse } from '@angular/common/http';
import { schoolFullRegistrationRequestListService } from './schoolfullregistrationrequestlist.service';
declare var $: any;

@Component({
  selector: 'app-schoolfullregistrationrequestlist',
  templateUrl: './schoolfullregistrationrequestlist.component.html',
  styleUrls: ['./schoolfullregistrationrequestlist.component.css']
})
export class SchoolfullregistrationrequestlistComponent implements OnInit {
  p: number = 1;
  responseData: any;
  registrationlist: Array<any>;
  pageLimit = global.pageLimit;
  searchtext;
  orderByField = "Board";
  reverseSort = false;
  dataTable: any;
  isDesc: boolean;
  column: string;
  totalPages = 10;
  totalRequest : any;
  constructor(private service: schoolFullRegistrationRequestListService, private toastr: ToastrService, private spinner: NgxSpinnerService, private router: Router) { }

  ngOnInit(): void {
    if (localStorage.length == 0 || localStorage.getItem("token") == "" || localStorage.getItem("token") == undefined) {
      this.router.navigate(['/aciadmin']);
      return;
    }
    document.getElementById('YearID').addEventListener('change', () => {
      this.GetRegistrationRequestList(this.p);
});
    $("#searchtext").val("");
    this.GetRegistrationRequestList(this.p);
  }
  GetRegistrationRequestList(page) {
    this.spinner.show();
    this.p = page;
    var search = "";
    if($("#searchtext").val() != undefined || $("#searchtext").val() != null || $("#searchtext").val() != ""){
      search = $("#searchtext").val();
    }
    const data = {
      SearchText : search,
      OffSet : (this.p - 1) * this.pageLimit,
      pagelimit : this.pageLimit,
      YearID : localStorage.getItem("YearID")
    };
    this.service.GetFullRegistrationRequestList(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        this.registrationlist = undefined;
        if (this.responseData.tokenStatus == false) {
          localStorage.clear();
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/aciadmin']);
        }
        if(!this.responseData.userRightsStatus){
          this.toastr.error(this.responseData.message);
          //this.router.navigate(['/aciadmin']);
          return;
        }
        if (this.responseData.status == false) {
          //this.toastr.error(this.responseData.message);
        } else {
          this.registrationlist = this.responseData.SchoolRegistrationRequestLists;
        //  this.totalPages = this.responseData.totalPages;
          this.totalRequest = this.responseData.totalCount;
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/aciadmin']);
      });
  }

  editRegistration(id) {
    this.router.navigate(['/schoolfullregistrationrequestadmin/' + id]);
  }
  sortBy(field: string) {
    this.isDesc = !this.isDesc; //change the direction    
    this.column = field;
    let direction = this.isDesc ? 1 : -1;

    this.registrationlist.sort(function (a, b) {
      if (a[field] < b[field]) {
        return -1 * direction;
      }
      else if (a[field] > b[field]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
    });
  }
  setpage() {
    this.p = 1;
  }
}
